<template>
  <section id="how-it-works" class="has-divider bg-primary-alt">
    <div class="container pt-5">
      <div class="row justify-content-center text-center mb-5">
        <div class="col-xl-8 col-lg-9">
          <h2 class="display-4 mx-xl-6">How it works</h2>
          <p class="lead">You are only 3 steps away to get your first results.</p>
        </div>
      </div>
      <div class="row justify-content-between align-items-center o-hidden">
        <div class="col-md-6 col-lg-5">
          <div class="d-flex mb-4">
            <div class="icon-round bg-primary h2">📚</div>
            <div class="ml-3">
              <h5>1. Gather some data</h5>
              <p>Use our converters to create a corpus of documents you want to explore.</p>
            </div>
          </div>
          <div class="d-flex mb-4">
            <div class="icon-round bg-primary h2">📈</div>
            <div class="ml-3">
              <h5>2. Train powerful algorithms</h5>
              <p>Connect our machine learning models to your corpus and enable a new way to search.</p>
            </div>
          </div>
          <div class="d-flex mb-4">
            <div class="icon-round bg-primary h2">🔌</div>
            <div class="ml-3">
              <h5>3. Share your results</h5>
              <p>Evaluate your question answering system and deploy a user interface on your servers.</p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <img src="../assets/img/how-it-works.svg" alt="Image">
        </div>
      </div>
    </div>
    <div class="divider">
      <svg
        width="100%"
        height="100%"
        version="1.1"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        preserveAspectRatio="none"
      >
        <path
          d="M0,0 C6.83050094,50 15.1638343,75 25,75 C41.4957514,75 62.4956597,0 81.2456597,0 C93.7456597,0 99.9971065,0 100,0 L100,100 L0,100"
          fill="#ffffff"
        ></path>
      </svg>
    </div>
  </section>
</template>

<script>
export default {
  name: "HowItWorks"
};
</script>

<style>
</style>